let rootStyle
const getCssVar = name => {
  if (!rootStyle)
    rootStyle = getComputedStyle(document.documentElement)
  return rootStyle.getPropertyValue(name)
}

export default getCssVar
